import React from "react";
import { CardStyles, Header } from "./Card.styled";
import PropTypes from "prop-types";

function CardLayout({ children, type }) {
	return (
		<CardStyles>
			<Header>
				<p className='type'>{type}</p>
				<select name='class' required defaultValue='2023'>
					<option value='' disabled defaultValue>
						Select year
					</option>
					{/* <option value="2021">2021</option>
                    <option value="2022">2022</option> */}
					<option value='2023'>2023</option>
				</select>
			</Header>
			{children}
		</CardStyles>
	);
}

CardLayout.propTypes = {
	children: PropTypes.node,
	type: PropTypes.string,
};

export default CardLayout;
